import { render, staticRenderFns } from "./SubmissionSteps.vue?vue&type=template&id=6ab8fd62&"
import script from "./SubmissionSteps.vue?vue&type=script&lang=js&"
export * from "./SubmissionSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeBenefits: require('/opt/render/project/src/channels2022/src/components/home-page/HomeBenefits.vue').default})
